import { api } from '../../core/network/api';

/** design/gdd/tutorial.md — progress only; the script itself never leaves the client. */

export interface TutorialState {
  seen: string[];
  skipped: boolean;
  completedAt: string | null;
}

export const getTutorialState = (): Promise<TutorialState> => api.get('/tutorial');

export const markTutorialStepSeen = (stepId: string): Promise<TutorialState> =>
  api.post('/tutorial/seen', { stepId });

export const skipTutorial = (): Promise<TutorialState> => api.post('/tutorial/skip');

export const completeTutorial = (): Promise<TutorialState> => api.post('/tutorial/complete');

/** Settings' "Replay the tutorial". */
export const resetTutorial = (): Promise<TutorialState> => api.post('/tutorial/reset');
